import React from 'react';
import INotSignedInProps from './INotSignedInProps';

//IMAGES
import { Building2, Linkedin } from 'lucide-react';
import video from '../../assets/video/AFA - Banner.mp4';
import imageEntitats from '../../assets/icons/Tràmits entitats.svg';
import logo from '../../assets/logos/Logotipo.svg';
import twitter from '../../assets/icons/twitter.svg';
import linkedIn from '../../assets/icons/linkedin.svg';

//SCSS//
import "./NotSignedIn.scss";

class NotSignedIn extends React.Component<INotSignedInProps, {}> {
    render() {
        return (
            <div className="oficina-virtual">
                <video className="background-video" autoPlay loop muted playsInline>
                    <source src={video} type="video/mp4" />
                </video>
                <div className="overlay"></div>

                <header className="header">
                    <div className="logo">
                        <img src={logo} />
                    </div>
                </header>

                <main className="main-content">
                    <h1 className="title">Oficina Virtual</h1>
                    <p className="subtitle">
                        Aquest accés està reservat a les entitats supervisades per l'AFA i als seus<br />
                        representants autoritzats.
                    </p>

                    <div className="card" onClick={this.props.loginButtonClicked}>
                        <img src={imageEntitats} className="card-icon"/>
                        {/* <div className="card-icon">
                            <Building2 size={48} strokeWidth={1.5} />
                        </div> */}
                        <h2 className="card-title">Entitats Supervisades</h2>
                        <p className="card-description">
                            Consulta i tramita amb el teu perfil d'entitat
                        </p>
                    </div>
                </main>

                <footer className="footer">
                    <div className="social-icons">
                        <a href="https://www.linkedin.com/company/afa-andorra" className="social-link" aria-label="LinkedIn">
                            <img src={linkedIn} />
                        </a>
                        <a href="https://twitter.com/AFA_Andorra" className="social-link" aria-label="Twitter">
                            <img src={twitter} />
                        </a>
                    </div>
                    <nav className="footer-nav">
                        <a href="https://www.afa.ad/ca/avis-legal" className="footer-link">Avís legal</a>
                        <span className="separator">·</span>
                        <a href="https://www.afa.ad/ca/politica-de-cookies" className="footer-link">Política de Cookies</a>
                        <span className="separator">·</span>
                        <a href="https://www.afa.ad/ca/politica-de-privacitat" className="footer-link">Política de Privacitat</a>
                    </nav>
                    <p className="copyright">
                        Copyright © 2025 Autoritat Financera Andorrana – Tots els drets reservats
                    </p>
                </footer>
            </div>
        );
    }
}

export default NotSignedIn;